'use client';

import React, {FC, useState} from 'react';
import {useRouter} from 'next/navigation';

import {useTimeoutAction} from '@/hooks/useTimeoutAction/';

import {scoreFromFormData} from '../../scoring';
import {useFhs} from '../../store/FhsContext/hooks';
import {clearCurrentAnswers, writeCompletedAnswers} from '../../store/storage';
import {firstNameFrom, logFhsFormSubmitted} from '../../utils';

import LockedOverlay from './components/LockedOverlay';
import ResultsView from './components/ResultsView';
import {TRANSITION_MS} from './constants';

const StepUnlockResults: FC = () => {
  const {formData} = useFhs();
  const {replace} = useRouter();
  const scoreResult = scoreFromFormData(formData);

  // `isLockOpen` state controls the LockedOverlay's exit transition.
  const [isLockOpen, setIsLockOpen] = useState(true);

  const scheduleNav = useTimeoutAction();

  const handleUnlock = (): void => {
    // Write in LocalStorage the completed answers and clear the current answers.
    writeCompletedAnswers(formData);
    clearCurrentAnswers();
    // log the form submitted event.
    logFhsFormSubmitted();
    setIsLockOpen(false);
    scheduleNav(
      () => replace('/financial-health-score?results'),
      TRANSITION_MS,
    );
  };

  return (
    <>
      <ResultsView
        firstName={firstNameFrom(formData.fullName)}
        result={scoreResult}
      />
      <LockedOverlay
        isOpen={isLockOpen}
        onUnlock={handleUnlock}
        fullName={formData.fullName ?? ''}
        leadPayload={{formData, result: scoreResult}}
      />
    </>
  );
};

export default StepUnlockResults;
